export enum TranslationStatuses {
  PENDING_TRANSLATION = 'EN ATTENTE DE TRADUCTION',
  TRANSLATION_DONE = 'TRADUCTION OK',
}